<div class="card">
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-xl font-semibold">
      {{ phaseConfig().translationKeys.title | transloco }}
    </h2>
    @if (shouldShowTable()) {
      <app-send-invitation-button
        [projectId]="projectId()"
        [currentPhase]="currentPhase()"
        [suggestedSubmissionDate]="suggestedSubmissionDate()"
        [hasUninvitedParticipants]="hasUninvitedParticipants()"
        (invited)="onSubmissionDateUpdated()"
      />
    }
  </div>

  @if (isLoading()) {
    <app-loading />
  } @else if (showPreviousPhaseNotFinishedMessage()) {
    <app-no-data label="project.steps.previousPhaseNotFinished" />
  } @else {
    <app-timeframe-display
      [projectId]="projectId()"
      [config]="finalTimeframeConfig()"
      [isReadOnly]="isReadOnly()"
      (submissionDateUpdated)="onSubmissionDateUpdated()"
    />
    @if (tableConfig().quickFilter; as quickFilter) {
      <div class="mb-3 flex flex-wrap items-center justify-between gap-3">
        <span class="text-muted-color text-sm">{{ quickFilter.hintKey | transloco }}</span>
        <div class="flex items-center gap-2">
          <app-model-field-text
            id="invitation-table-search"
            [placeholder]="quickFilter.searchPlaceholderKey"
            [value]="searchQuery()"
            (valueChange)="searchQuery.set($event)"
          />
          <app-model-field-select
            id="invitation-table-quick-filter"
            [options]="quickFilterOptions()"
            optionLabel="label"
            optionValue="value"
            [showClear]="false"
            [value]="selectedQuickFilterValue()"
            (valueChange)="quickFilterValue.set($event)"
          />
        </div>
      </div>
    }
    <p-table
      [value]="visibleToolItems()"
      [paginator]="true"
      [rows]="tableConfig().rows ?? 15"
      [showCurrentPageReport]="true"
      [currentPageReportTemplate]="'common.table.currentPageReportTemplate' | transloco"
      [globalFilterFields]="['translatedName', 'name', 'status']"
      [sortField]="tableConfig().defaultSortField"
      [sortOrder]="tableConfig().defaultSortOrder ?? 1"
    >
      <ng-template #header>
        <tr>
          @for (column of tableConfig().columns; track column.field) {
            <th
              [pSortableColumn]="column.sortable ? (column.sortField ?? column.field) : undefined"
              [style.width]="column.width"
              scope="col"
            >
              <span class="inline-flex items-center gap-2">
                {{ column.header | transloco }}
                @if (column.sortable) {
                  <p-sortIcon [field]="column.sortField ?? column.field"></p-sortIcon>
                }
                @if (column.filter) {
                  <app-table-column-filter [field]="column.field" />
                }
                @if (column.headerTooltip; as tooltipText) {
                  <i
                    class="pi pi-info-circle text-sm cursor-pointer hover:text-gray-400 transition-colors"
                    [pTooltip]="tooltipText"
                    [escape]="false"
                    tooltipPosition="right"
                    tooltipStyleClass="directus-tooltip invitation-table-header-tooltip"
                  ></i>
                }
              </span>
            </th>
          }
        </tr>
      </ng-template>

      <ng-template #body let-item>
        <tr>
          @for (column of tableConfig().columns; track column.field) {
            <td>
              @if (column.template) {
                <ng-container
                  *ngTemplateOutlet="column.template; context: {$implicit: item, column: column}"
                ></ng-container>
              } @else if (column.field === 'selection') {
                <app-participating-tool-selection
                  [item]="item"
                  [phaseConfig]="phaseConfig()"
                  [currentPhase]="currentPhase()"
                  (selectionChange)="onSelectionChangeWrapper({item: item, newSelection: $event})"
                />
              } @else if (column.field === 'status') {
                <app-invitation-status-tag [status]="item.status ?? null" />
              } @else {
                <span class="inline-flex items-center gap-2">
                  {{ getFieldValue(item, column) }}
                  @if (getCellTooltip(item, column); as tooltipText) {
                    <i
                      class="pi pi-info-circle text-sm cursor-pointer hover:text-gray-400 transition-colors"
                      [pTooltip]="tooltipText"
                      [escape]="false"
                      [appendTo]="'body'"
                      tooltipStyleClass="directus-tooltip"
                    ></i>
                  }
                </span>
              }
            </td>
          }
        </tr>
      </ng-template>

      <ng-template #emptymessage>
        <tr>
          <td [attr.colspan]="tableConfig().columns.length">
            <app-no-data [label]="tableConfig().emptyMessage" />
          </td>
        </tr>
      </ng-template>
    </p-table>
  }

  <app-max-participants-dialog
    [visible]="maxParticipantsDialogVisible()"
    [maxAllowedParticipants]="maxAllowedParticipants()"
    (visibleChange)="maxParticipantsDialogVisible.set($event)"
  />
</div>
